export enum stepperEnum {
    firstStep = 0,
    secondStep = 1,
    thirdStep = 2
} 

export enum operationEnum {
    cancel = "cancel",
    archive = "archive",
    download = "download",
    open = "open"
}

export enum operationActionEnum {
    save = "save",
    update = "update",
    reload = "reload"
}

export enum placeholderEnum {
    section = "section",
    element = "element",
    predicate = "predicate",
    chooseValue = "chooseValue",
    enterValue = "enterValue",
    chooseAction = "chooseAction"
}